export const HEADER_DROPDOWN_IDS = {
    MAIN_HEADER: 'mainHeaderDropdown',
    SUB_HEADER: 'subHeaderDropdown'
};
export const DROPDOWN_MENU_MODAL_ID = 'dropdownMenuModal';

export const DROPDOWN_CONTAINER_IDENTIFIER = 'subHeaderDropdownContainer';
export const DROPDOWN_SECTION_IDENTIFIER = 'subheaderDropdownSection';
